import type en from './en';

const de: typeof en = {
  menu: {
    view: "Ansicht",
    suggest: "Vorschlagen",
    admin: "Admin",
    user: "Benutzer",
    filter: "Filter",
    search: "Filter",
    import_menu: "Importieren",
    export: "Exportieren",
    stamp: "Briefmarke",
    set: "Serie",
    block: "Block",
    booklet: "Markenheftchen",
    seTenants: "Zusammendrucke",
    deleteDatabase: "Datenbank löschen",
    exportAdmin: "Exportieren",
    importAdmin: "Importieren",
    dumpToConsole: "In Konsole ausgeben",
    userDashboard: "Benutzer-Dashboard",
    help: "Hilfe",
    login: "Anmelden",
    logout: "Abmelden",
    changeUser: "Benutzer wechseln",
    role: "Rolle: ",
  },
  userDashboard: {
    title: "Benutzer-Dashboard",
    description: "Übersicht aller Benutzer und ihrer Aktivitäten.",
    name: "Name",
    email: "E-Mail",
    role: "Rolle",
    id: "ID",
    loading: "Wird geladen…",
    error: "Benutzerdaten konnten nicht geladen werden.",
  },
  userDetail: {
    title: "Benutzerdetails",
    description: "Aktivitätsübersicht für diesen Benutzer.",
    loading: "Wird geladen…",
    error: "Benutzerdetails konnten nicht geladen werden.",
    suggestions: "Vorschläge",
    suggestionsTotal: "Gesamt",
    accepted: "Akzeptiert",
    rejected: "Abgelehnt",
    inReview: "In Prüfung",
    notInReview: "Noch nicht in Prüfung",
    reviews: "Prüfungen",
    reviewsTotal: "Gesamt",
  },
  errors: {
    postStampSuggestion: "Fehler beim Einreichen des Briefmarken-Vorschlags: ",
    postSetSuggestion: "Fehler beim Einreichen des Serien-Vorschlags: ",
    postBlockSuggestion: "Fehler beim Einreichen des Block-Vorschlags: ",
    postBookletSuggestion: "Fehler beim Einreichen des Markenheftchen-Vorschlags: ",
    postSeTenantsSuggestion: "Fehler beim Einreichen des Zusammendrucke-Vorschlags: ",
    dumpToConsole: "Fehler bei der Konsolenausgabe: ",
    deleteAll: "Fehler beim Löschen aller Einträge und Vorschläge: ",
    markAsInReview: "Fehler beim Markieren als 'In Prüfung': ",
    reviewFailed: "Prüfung fehlgeschlagen: ",
    importItems: "Fehler beim Importieren der philatelistischen Einträge: ",
    deleteSuggestion: "Fehler beim Löschen des Vorschlags: ",
    deleteUser: "Fehler beim Löschen des Benutzers: ",
  },
  login: {
    title: "Anmelden",
    description: "Bitte E-Mail-Adresse und Passwort eingeben.",
    email: "E-Mail",
    password: "Passwort",
    button: "Anmelden",
    cancel: "Abbrechen",
  },
  import: {
    title: "Importieren",
    description: "Inhalt der Datendatei prüfen und in die Datenbank importieren.\nDies überschreibt alle vorhandenen Einträge.",
    dataFile: "Datendatei",
    numberOfEntries: "Anzahl der Einträge",
    notAvailable: "N/V",
    button: "Importieren",
    importing: "Importiere …",
    close: "Schließen",
    done: "Import abgeschlossen.",
  },
  editor: {
    /** Verbindet den Untertitel eines Details-/Prüfdialogs mit dem Namen des Einsenders. */
    suggestedBy: "von",
    stampEditorTitle: "Briefmarken-Editor",
    stampEditorSubtitle: "Briefmarken-Vorschlag erstellen",
    stampDetailsTitle: "Briefmarkendetails",
    stampDetailsSuggestionSubtitle: "Details eines Briefmarken-Vorschlags",
    stampDetailsCatalogSubtitle: "Details einer Briefmarke aus dem Katalog",
    stampReviewTitle: "Briefmarken-Prüfeditor",
    stampReviewSubtitle: "Vorschlag bearbeiten und prüfen",
    setEditorTitle: "Serien-Editor",
    setEditorSubtitle: "Serien-Vorschlag erstellen",
    setDetailsTitle: "Seriendetails",
    setDetailsSuggestionSubtitle: "Details eines Serien-Vorschlags",
    setDetailsCatalogSubtitle: "Details einer Serie aus dem Katalog",
    setReviewTitle: "Serien-Prüfeditor",
    setReviewSubtitle: "Vorschlag bearbeiten und prüfen",
    blockEditorTitle: "Block-Editor",
    blockEditorSubtitle: "Block-Vorschlag erstellen",
    blockDetailsTitle: "Block-Details",
    blockDetailsSuggestionSubtitle: "Details eines Block-Vorschlags",
    blockDetailsCatalogSubtitle: "Details eines Blocks aus dem Katalog",
    blockReviewTitle: "Block-Prüfeditor",
    blockReviewSubtitle: "Vorschlag bearbeiten und prüfen",
    addBlockSuggestion: "Vorschlag einreichen",
    bookletEditorTitle: "Markenheftchen-Editor",
    bookletEditorSubtitle: "Markenheftchen-Vorschlag erstellen",
    bookletDetailsTitle: "Markenheftchen-Details",
    bookletDetailsSuggestionSubtitle: "Details eines Markenheftchen-Vorschlags",
    bookletDetailsCatalogSubtitle: "Details eines Markenheftchens aus dem Katalog",
    bookletReviewTitle: "Markenheftchen-Prüfeditor",
    bookletReviewSubtitle: "Vorschlag bearbeiten und prüfen",
    addBookletSuggestion: "Vorschlag einreichen",
    seTenantsEditorTitle: "Zusammendrucke-Editor",
    seTenantsEditorSubtitle: "Zusammendrucke-Vorschlag erstellen",
    seTenantsDetailsTitle: "Zusammendrucke-Details",
    seTenantsDetailsSuggestionSubtitle: "Details eines Zusammendrucke-Vorschlags",
    seTenantsDetailsCatalogSubtitle: "Details eines Zusammendrucks aus dem Katalog",
    seTenantsReviewTitle: "Zusammendrucke-Prüfeditor",
    seTenantsReviewSubtitle: "Vorschlag bearbeiten und prüfen",
    addSeTenantsSuggestion: "Vorschlag einreichen",
    done: "Fertig",
    selectStamps: "Briefmarken auswählen",
    stampInSetTitle: "Briefmarken-in-Serien-Editor",
    stampInSetSubtitle: "Briefmarkeneintrag zu einer Serie erstellen",
    accept: "Akzeptieren",
    reject: "Ablehnen",
    addStampSuggestion: "Vorschlag einreichen",
    addSetSuggestion: "Vorschlag einreichen",
    addStampToSet: "Briefmarke zur Serie hinzufügen",
    moveStampUp: "Marke nach oben schieben",
    moveStampDown: "Marke nach unten schieben",
    removeStamp: "Marke aus der Serie entfernen",
    removeStampConfirm: "Diese Marke entfernen?",
    save: "Speichern",
    add: "Hinzufügen",
    stamps: "Briefmarken",
  },
  fields: {
    title: "Titel",
    titlePlaceholder: "Titel",
    description: "Beschreibung",
    descriptionPlaceholder: "Beschreibung",
    issueDate: "Ausgabedatum",
    expiryDate: "Ablaufdatum",
    clearExpiryDate: "Ablaufdatum löschen",
    size: "Größe",
    printRun: "Auflage",
    width: "B",
    height: "H",
    mm: "mm",
    faceValue: "Nennwert",
    faceValuePlaceholder: "0",
    selectUnit: "Einheit auswählen",
    unit: "Einheit",
    perforation: "Perforation",
    perforationType: "Typ",
    selectType: "Typ auswählen",
    horizontal: "H:",
    vertical: "V:",
    photoScan: "Foto/Scan",
    gum: {
      label: "Gummierung",
      unset: "Keine Angabe",
      none: "Nicht gummiert",
      dull: "Glanzlos gummiert",
      glossy: "Glänzend gummiert",
      adhesive: "Selbstklebend",
    },
    color: {
      label: "Farbe",
      multiColored: "Mehrfarbig",
      primary: "Hauptfarbe",
      secondary: "Nebenfarbe",
    },
    perforationTypeLabels: {
      Imperforated: "ungezähnt",
      Line: "Linienzähnung",
      Comb: "Kammzähnung",
      Diecutting: "Stanzung",
    },
    securityPerforation: {
      label: "Sicherheitszähnung",
      short: "Sicherheitszähnung",
      button: "Sicherheitszähnung",
      enabled: "Sicherheitszähnung vorhanden",
      shape: "Form des Sonderlochs",
      shapeText: "Bezeichnung",
      shapeTextPlaceholder: "z. B. Herz",
      holesPerSide: "Sonderlöcher pro Seite",
      perSideShort: "Seite",
      scope: "Betroffene Seiten",
      innerSeparationOnly: "Nur Innentrennung",
      innerSeparationOnlyShort: "nur Innentrennung",
      position: "Position in der Lochreihe",
      positionIndex: "Nummer des Lochs",
      orientation: "Lage der Längsachse",
      dimensions: "Maß erfassen",
      diameter: "Durchmesser",
      majorAxis: "Hauptachse",
      minorAxis: "Nebenachse",
      circumradius: "Umkreisradius",
      circumradiusShort: "Umkreis",
      inradius: "Inkreisradius",
      inradiusShort: "Inkreis",
      points: "Anzahl Zacken",
      pointsShort: "Zacken",
      shapes: {
        Round: "Kreis",
        Ellipse: "Ellipse",
        Cross: "Kreuzform",
        Star: "Stern",
        Rhombus: "Raute",
        Motif: "Motivform",
      },
      scopes: {
        AllFour: "alle vier Seiten",
        HorizontalOnly: "nur waagerecht",
        VerticalOnly: "nur senkrecht",
      },
      positionLabels: {
        Center: "mittig",
        Nth: "n-tes Loch",
      },
      positions: {
        Center: "mittig",
        Nth: "{n}-tes Loch",
      },
      orientations: {
        ParallelToRow: "parallel zur Lochreihe",
        PerpendicularToRow: "senkrecht zur Lochreihe",
      },
    },
  },
  list: {
    items: "Einträge",
    suggestions: "Vorschläge",
    own: "Eigene",
    reviewOwned: "Eigene Prüfungen",
    addStamp: "+ Briefmarke",
    addSet: "+ Serie",
    addBlock: "+ Block",
    addBooklet: "+ Markenheftchen",
    addSeTenants: "+ Zusammendrucke",
    search: "Filter",
  },
  search: {
    title: "Suche & Filter",
    description: "Liste nach den gewählten Kriterien filtern.",
    enabled: "aktiv",
    disabled: "inaktiv",
    dateFrom: "Ausgabedatum Von",
    dateTo: "Ausgabedatum Bis",
    ownOnly: "Von mir vorgeschlagen",
    reviewedByMe: "Von mir geprüft",
    descriptionWords: "Beschreibungswörter",
    descriptionWordsPlaceholder: "Wort1 Wort2 ...",
    zhihaoPlaceholder: "z. B. 2018-2 oder J.100",
    itemTypes: "Eintragstypen",
    reviewStates: "Prüfzustände",
    reset: "Zurücksetzen",
    dateFrom_short: "ab",
    dateTo_short: "bis",
    nTypes: "{n} Typen",
    singleStamp: "Einzelmarke",
    stampFromSet: "Briefmarke aus Serie",
    reviewStateSuggested: "Vorgeschlagen",
    reviewStateInReview: "In Prüfung",
    reviewStateAccepted: "Akzeptiert",
    reviewStateRejected: "Abgelehnt",
  },
  review: {
    markAsInReview: "Als 'In Prüfung' markieren",
    notInReview: "Nicht in Prüfung",
    inReviewByOther: "In Prüfung durch jemand anderen",
    inReviewByYou: "In Prüfung durch Sie",
    inReviewByYouClickToDrop: "In Prüfung durch Sie — klicken, um die Prüfung abzugeben",
    rejected: "Abgelehnt",
  },
  buttons: {
    details: "Details",
    review: "Prüfen",
    edit: "Bearbeiten",
    delete: "Löschen",
    collapse: "Einklappen",
    expand: "Ausklappen",
  },
  deleteSuggestion: {
    title: "Vorschlag löschen",
    subtitle: "Bitte den Vorschlag prüfen, bevor er gelöscht wird.",
    warning: "Soll dieser Vorschlag wirklich gelöscht werden?",
    confirm: "Löschen bestätigen",
    cancel: "Abbrechen",
  },
  validation: {
    titleEmpty: "Titel darf nicht leer sein",
    descriptionEmpty: "Beschreibung darf nicht leer sein",
    dateNotSet: "Ausgabedatum muss gesetzt sein",
    faceValueNotSet: "Nennwert muss gesetzt sein",
    faceValueZero: "Nennwert muss größer als 0 sein",
    faceValueUnitNotSet: "Nennwert-Einheit muss gesetzt sein",
    pictureNotSet: "Ein Bild muss gesetzt sein",
    perforationTypeNotSet: "Perforationstyp muss gesetzt sein",
    perforationHorizontalZero: "Horizontale Perforationszahl muss größer als 0 sein",
    perforationVerticalZero: "Vertikale Perforationszahl muss größer als 0 sein",
    securityHoleShapeNotSet: "Die Form des Sonderlochs muss gesetzt sein",
    securityHoleShapeTextMissing: "Für eine Motivform muss eine Bezeichnung angegeben werden",
    securityHoleCountInvalid: "Die Anzahl der Sonderlöcher pro Seite muss größer als 0 sein",
    securityHoleScopeNotSet: "Die betroffenen Seiten müssen gesetzt sein",
    securityHolePositionIndexInvalid: "Die Nummer des Lochs muss größer als 0 sein",
    securityHoleOrientationNotSet: "Die Lage der Längsachse muss gesetzt sein",
    securityHoleDimensionsMismatch: "Das erfasste Maß passt nicht zur gewählten Form",
    securityHoleDimensionsIncomplete: "Das Maß des Sonderlochs ist unvollständig",
    securityHoleAxesSwapped: "Die Nebenachse darf nicht größer als die Hauptachse sein",
    securityHoleRadiiSwapped: "Der Inkreis darf nicht größer als der Umkreis sein",
    securityHoleStarPointsInvalid: "Ein Stern braucht mindestens 3 Zacken",
    noStampsSelected: "Mindestens eine Briefmarke muss ausgewählt werden",
    noStampsInSet: "Eine Serie muss mindestens eine Briefmarke enthalten",
    zhihaoPrefixUnknown: "Unbekanntes Zhihao-Präfix",
    zhihaoIncomplete: "Der Zhihao ist unvollständig",
    zhihaoPositionExceedsSetSize: "Die Position darf nicht größer als die Satzgröße sein",
  },
  catalogIds: {
    button: "Kataloge",
    clear: "Löschen",
  },
  zhihao: {
    button: "Zhihao",
    clear: "Löschen",
    prefix: "Präfix",
    year: "Jahr",
    series: "Ausgabe-Nr.",
    setSize: "Satzgröße",
    position: "Position",
    preview: "Vorschau",
    showAll: "Alle Präfixe anzeigen",
    showMatching: "Nur zum Datum passende Präfixe",
    epochMismatch: "Dieses Präfix gehört nicht zur Epoche des Ausgabedatums",
    inheritedFromSet: "Von der Serie übernommen",
    positionPerStamp: "Die Position ergibt sich je Marke aus ihrem Platz in der Serie.",
    positionOnlyInSet: "Eine Position innerhalb einer Ausgabe wird erst im Serien-Editor vergeben.",
    epochs: {
      Early: "1949-1967",
      Wen: "1967-1970 (文)",
      Numbered: "1970-1973 (编号)",
      JT: "1974-1991 (J/T)",
      Biannian: "ab 1992",
      Universal: "epochenübergreifend",
    },
    prefixLabels: {
      ji: "Gedenkmarke (纪)",
      te: "Sondermarke (特)",
      gai: "Überdruckausgabe (改)",
      qian: "Nachportomarke (欠)",
      jun: "Militärpost (军)",
      hang: "Flugpost (航)",
      wen: "Kulturrevolution (文)",
      numbered: "Nummerierte Ausgabe (编号)",
      J: "Gedenkmarke (J)",
      T: "Sondermarke (T)",
      teSpecial: "Sonderausgabe (特)",
      he: "Grußmarke (贺)",
      ge: "Personalisierungsmarke (个)",
      fu: "Zuschlagsmarke (附)",
      pu: "Dauermarke (普)",
      SB: "Markenheftchen (SB)",
    },
  },
  labels: {
    button: "Kategorien",
    original_edition: "Originalauflage",
    reprint: "Nachdruck",
    exists_with_imprint_jp5: "Existiert mit Aufdruck JP 5",
  },
  alt: {
    stamp: "Briefmarke",
    aStamp: "Eine Briefmarke",
  },
  mobile: {
    invalidTitle: "Ungültiger Link",
    invalidText: "Diesem Upload-Link fehlt ein Token. Bitte den QR-Code erneut scannen.",
    idleTitle: "Foto hochladen",
    idleText: "Nimm ein Foto der Briefmarke auf oder wähle ein vorhandenes Bild.",
    choosePhoto: "📷 Foto aufnehmen / auswählen",
    detectingTitle: "Analysiere…",
    detectingText: "Erkenne Markengrenzen.",
    cropTitle: "Ausschnitt anpassen",
    cropText: "Ecken ziehen zum Verfeinern.",
    retake: "↩ Neu aufnehmen",
    useCrop: "✓ Ausschnitt verwenden",
    uploadingTitle: "Wird hochgeladen…",
    uploadingText: "Bitte warten.",
    successTitle: "✓ Foto empfangen!",
    successText: "Diese Seite kann geschlossen und zum Editor zurückgekehrt werden.",
    errorTitle: "Hochladen fehlgeschlagen",
    errorText: "Bitte zurückgehen und erneut versuchen.",
  },
  registerUser: {
    title: "Benutzer registrieren",
    description: "Neues Benutzerkonto erstellen.",
    name: "Name",
    namePlaceholder: "Vollständiger Name",
    email: "E-Mail",
    password: "Passwort",
    role: "Rolle",
    button: "Registrieren",
    menuItem: "Benutzer registrieren",
    errorNameEmpty: "Name darf nicht leer sein.",
    errorEmailEmpty: "E-Mail darf nicht leer sein.",
    errorPasswordEmpty: "Passwort darf nicht leer sein.",
    errorRoleNotSet: "Eine Rolle muss ausgewählt werden.",
  },
  mode: {
    creatorMode: "Einsende-Modus",
    catalogMode: "Katalog-Modus",
  },
  orientation: {
    title: "Bitte Gerät drehen",
    message: "Dieser Katalog ist für das Hochformat ausgelegt. Bitte halten Sie Ihr Gerät aufrecht.",
  },
  roles: {
    Viewer: "Betrachter",
    Contributor: "Einsender",
    Reviewer: "Prüfer",
    Admin: "Admin",
  },
  upload: {
    chooseFile: "Datei auswählen",
    replaceFile: "Datei ersetzen",
    addPhoto: "Foto hinzufügen",
    removePhoto: "Foto entfernen",
    button: "Vom Handy hochladen",
    title: "Vom Handy hochladen",
    description: "Scanne den QR-Code mit deinem Handy, um ein Foto aufzunehmen oder hochzuladen.",
    waiting: "Warte auf Foto…",
    generating: "QR-Code wird generiert…",
    validFor: "Noch {s} Sekunden gültig",
    expired: "QR-Code abgelaufen. Bitte Dialog schließen und erneut öffnen.",
    success: "Foto empfangen!",
    error: "Upload fehlgeschlagen.",
  },
};

export default de;
